import {
	IFinancialReportResponceWithPagination,
	IGetMaxBidsResponse,
	IGetParticipantsResponse,
	IGetUnpaidItemsResponse,
	IGetUnpaidTablesResponse,
	IOrganizationFullReportColumns,
	IOrganizationReportReducer,
} from '@/utils/types/organization-reports.interface';
import {PayloadAction} from '@reduxjs/toolkit';

export const pendingOperation = (state: IOrganizationReportReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationReportReducer) => {
	state.isLoading = false;
};

export const getUnpaidItemsOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IGetUnpaidItemsResponse>
) => {
	state.isLoading = false;
	state.unpaidItems = payload;
};

export const getUnpaidTablesOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IGetUnpaidTablesResponse>
) => {
	state.isLoading = false;
	state.unpaidTables = payload;
};

export const getParticipantsOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IGetParticipantsResponse>
) => {
	state.isLoading = false;
	state.participants = payload;
};

export const getMaxBidsOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IGetMaxBidsResponse>
) => {
	state.isLoading = false;
	state.maxBids = payload;
};

export const getReportedColumnsOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IOrganizationFullReportColumns[]>
) => {
	state.isLoading = false;
	state.columns = payload;
};

export const getFinancialReportOperation = (
	state: IOrganizationReportReducer,
	{payload}: PayloadAction<IFinancialReportResponceWithPagination>
) => {
	state.isLoading = false;
	state.fullReport = payload;
};
